import React, { useState, useEffect, useRef } from "react";

const AUTO_SLIDE_MS = 4000;
const SWIPE_THRESHOLD = 40;

const getBannerInfo = (item) => {
  const isVote = item.type === "vote";
  return {
    emoji: item.bannerEmoji || (isVote ? "🏆" : "🔥"),
    text:
      item.bannerText ||
      (isVote ? "¡Votación Activa!" : "¡Vamos a hacer tendencia!"),
    tab: isVote ? "vote" : "trend",
  };
};

// Un solo item = banner normal. Dos o más = carrusel con auto-slide y puntitos.
const BannerCarousel = ({ items, onSelect }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchStartX = useRef(null);
  const swiped = useRef(false);
  const count = items.length;

  useEffect(() => {
    if (count < 2 || paused) return undefined;
    const id = setInterval(() => setIndex((i) => (i + 1) % count), AUTO_SLIDE_MS);
    return () => clearInterval(id);
  }, [count, paused, index]);

  if (count === 0) return null;

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    swiped.current = false;
    setPaused(true);
  };

  const handleTouchEnd = (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > SWIPE_THRESHOLD) {
      swiped.current = true;
      setIndex((i) => (dx < 0 ? (i + 1) % count : (i - 1 + count) % count));
    }
    setPaused(false);
  };

  return (
    <div className="w-full mb-4">
      <div
        className="overflow-hidden rounded-2xl trend-glow"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {items.map((item, i) => {
            const { emoji, text, tab } = getBannerInfo(item);
            return (
              <button
                key={`${item.type}-${item.campaignId || item.phrase || i}`}
                onClick={() => {
                  if (swiped.current) return;
                  onSelect(tab);
                }}
                className="w-full shrink-0 flex items-center gap-3 px-4 py-3 active:opacity-90"
                style={{ background: "linear-gradient(135deg, #f97316, #ef4444)" }}
                aria-hidden={i !== index}
                tabIndex={i === index ? 0 : -1}
              >
                <span style={{ fontSize: "18px" }}>{emoji}</span>
                <div className="text-left flex-1">
                  <p className="text-white font-bold text-sm leading-tight">{text}</p>
                </div>
                <span className="text-white text-lg">›</span>
              </button>
            );
          })}
        </div>
      </div>

      {count > 1 && (
        <div className="flex justify-center gap-1.5 mt-2">
          {items.map((item, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Ir al banner ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === index ? "w-4 bg-orange-500" : "w-1.5 bg-orange-300"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BannerCarousel;
